import DecryptedText from "@/components/framer/framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/hooks/useAuth";
import { ArrowLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const LoginEmail = () => {
  const navigate = useNavigate();
  const { user, signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!email || !password) {
      toast.error("Please fill in all fields");
      return;
    }
    setSubmitting(true);
    try {
      await signIn(email, password);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user, navigate]);

  return (
    <div className="flex justify-center items-center flex-1 w-full relative overflow-hidden border ">
      <div className="flex flex-col justify-center items-center gap-4 p-4 w-[410px] z-10">
        <form
          className="flex flex-col justify-center items-center gap-4 p-4 w-full"
          onSubmit={handleSubmit}
        >
          <h1 className="text-8xl">Nimbus</h1>
          <DecryptedText
            text="Manage your environment powerfully and easily"
            speed={50}
            maxIterations={50}
            animateOn="view"
            revealDirection="start"
            useOriginalCharsOnly={true}
            sequential={true}
          />
          <Input
            type="email"
            placeholder="Write your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            // required
          />
          <Input
            type="password"
            placeholder="Write your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            className="cursor-pointer w-full"
            type="submit"
            loading={submitting}
          >
            Login
          </Button>
          <p className="text-[10px] flex items-center justify-center gap-1">
            <span
              className="text-blue-700 cursor-pointer"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot your password?
            </span>
          </p>
          <p className="text-[10px] flex items-center justify-center gap-1">
            <ArrowLeft size={15} className="text-blue-700" />

            <span
              className="text-blue-700 cursor-pointer"
              onClick={() => navigate("/login")}
            >
              Other Login options
            </span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginEmail;
